import { AgGridTable } from 'components/AgGrid/AgGridTable';
import { AG_GRID_ICON_SETUP } from 'constantsProject';
import type { BimActKc2PriceRowData } from 'gql/graphql';

import type { ColDef } from 'ag-grid-community';
import type React from 'react';

import { useBimActKc2PricesColumns } from './hooks/useBimActKc2PricesColumns';
import { useBimActKc2PricesGroupedData } from './hooks/useBimActKc2PricesGroupedData';

import Style from './BimWorkOrderActKc2PriceDetails.module.css';

interface IBimWorkOrderPriceTotalDetails {
    pricesData?: BimActKc2PriceRowData[] | null;
    styleClass?: string;
    defaultColDef?: ColDef;
}

const getRowId = ({ data }: { data: BimActKc2PriceRowData }) => data?.id ?? data?.sectionId;

export const BimWorkOrderActKc2PriceDetails: React.FC<IBimWorkOrderPriceTotalDetails> = (props) => {
    const { styleClass, pricesData, defaultColDef } = props;

    const { rowData, changeFilterHandler, filterData } = useBimActKc2PricesGroupedData(pricesData);

    const columns = useBimActKc2PricesColumns(filterData, changeFilterHandler);

    return (
        <div className={`ag-theme-alpine ${styleClass} ${Style.bimWorkOrderActKc2PriceDetail}`}>
            <AgGridTable
                getRowId={getRowId}
                rowData={rowData}
                columnDefs={columns}
                overlayNoRowsTemplate="Нет данных"
                defaultColDef={defaultColDef}
                containerStyle={{ paddingBottom: 20 }}
                icons={AG_GRID_ICON_SETUP}
            />
        </div>
    );
};

BimWorkOrderActKc2PriceDetails.displayName = 'BimWorkOrderPriceTotalDetails';
